import '../views/administration/userReports/overview.html';

import { userReports } from '../services/arsweb/RoutingPaths';
import { EDITROUTE, EDITTITLE } from '../views/administration/userReports/EditUserReportController'
import { ADDROUTE, ADDTITLE, DELETEROUTE } from '../views/administration/userReports/AddUserReportController'

export const LISTROUTE = 'app.userReports';
export const LISTTITLE = 'USER_REPORTS';

export class UserReportsRouterStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {

        this.$stateProvider.state(LISTROUTE, {
            url: '/userReports',
            templateUrl: './app/views/administration/userReports/overview.html',
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: LISTTITLE
            }
        }).state(ADDROUTE, {
            url: '/addUserReport',
            templateUrl: './app/views/administration/userReports/detail.html',
            controller: 'AddUserReportController',
            controllerAs: 'userReportController',
            params: {
                pageTitle: ADDTITLE,
                editMode: 'create'
            }
        }).state(EDITROUTE, {
            url: '/editUserReport',
            templateUrl: './app/views/administration/userReports/detail.html',
            controller: 'EditUserReportController',
            controllerAs: 'userReportController',
            params: {
                id: null,
                pageTitle: EDITTITLE,
                editMode: 'edit'
            }
        }).state(DELETEROUTE, {
            url: '/deleteUserReport',
            templateUrl: './app/views/delete/confirmation.html',
            controller: 'DeleteConfirmationController',
            controllerAs: 'deleteConfirmationController',
            params: {
                names: null,
                ids: null,
                pKey: 'reportId',
                restUrl: userReports,
                pageTitle: "DELETE_USER_REPORTS",
                pageBody: 'CONFIRMATION_DELETE_USERREPORTS',
                deleteConfirmation: "DEACTIVATION_SUCCESS"
            }
        });
    }
}
